import { getGameItemConfig } from "@/stores/configStore.ts";
import { GameListAttrs } from "@locent/types";

import { BaseComponent } from "../base/baseComponent";
import { CompType, GameIconStyle, ProviderStyle } from "../base/baseEnum";
import { GameItem } from "../base/baseType";

/** 游戏列表组件类 */
export class GameListComponent extends BaseComponent<
  GameListAttrs & {
    [key: string]: string | number | boolean | object | null | undefined;
  }
> {
  constructor(
    data: Partial<
      BaseComponent<
        GameListAttrs & {
          [key: string]: string | number | boolean | object | null | undefined;
        }
      >
    > = {},
  ) {
    super(data);
    this.type = CompType.game_list;
  }

  /** 获取游戏列表 */
  public getGames(): GameItem[] {
    return this.games || [];
  }

  /** 获取游戏图标PC端网格大小 */
  public getGameIconGridPc(): number {
    return Number(this.lang_attrs.per_view_pc) || 7;
  }

  /** 获取游戏图标网格大小 */
  public getGameIconGridH5(): number {
    return Number(this.lang_attrs.per_view_h5) || 3;
  }

  /** 获取图标样式 */
  public getIconStyle(): string {
    return this.attrs.icon_style || GameIconStyle.Default;
  }

  /** 获取提供商样式 */
  public getProviderStyle(): string {
    return this.attrs.provider_style || ProviderStyle.Default;
  }

  /** 获取图标圆角 */
  public getIconRadius(): string {
    return this.lang_attrs.icon_set_type && this.lang_attrs.icon_radius
      ? String(this.lang_attrs.icon_radius)
      : getGameItemConfig().gameIconRadius;
  }

  /** 获取标题图标 */
  public getTitleIcon(): string {
    return this.title_icon;
  }

  /** 获取图标文件夹 */
  public getIconFolder(): string {
    return this.lang_attrs.icon_folder || "";
  }

  /** 获取扩展图标文件夹 */
  public getExtIconFolder(): string {
    return this.lang_attrs.ext_icon_folder || "";
  }

  /** 获取原始图标文件夹 */
  public getOrgIconFolder(): string {
    return this.lang_attrs.org_icon_folder || "";
  }
}

// // 使用示例
// const gameListData: Partial<BaseComponent<GameListAttrs>> = {
//   id: "670671e5aa4613e0d46a2770",
//   type: CompType.game_list,
//   variant: "1",
//   title: "",
//   status: 1,
//   sort: 0,
//   login_type: LoginType.Login,
//   recharge_type: RechargeType.Recharge,
//   fixed_top: 0,
//   key: "game_list_1728475620",
//   show_rtp: true,
//   height: "",
//   attrs: {
//     game_icon_grid_pc: 6.5,
//     icon_folder: "",
//     title_text: {
//       "11": "Jogos favoritos",
//       "12": "Juegos favoritos",
//       "1": "Favorite games",
//       "4": "喜爱游戏",
//     },
//     show_count: 0,
//     icon_style: "4",
//     icon_radius: "6",
//     title_type: 1,
//     title_icon: "5018",
//     line: 2,
//     game_icon_grid: 2.4,
//     icon_set_type: "2",
//     ext_icon_folder: "",
//     provider_style: "2",
//     org_icon_folder: "",
//   },
//   games: [
//     {
//       game_id: 5021,
//       name: "Mines2",
//       gplat: 10000,
//       gclass: 10,
//       jump: 2,
//       demo: true,
//       status: 1,
//       power: 648,
//       r: 591200,
//       rw: 930500,
//       s: [],
//       p: 0,
//       v: 0,
//       tag: 3,
//       currs: [
//         "PEN",
//         "INR",
//         "VND",
//         "CLP",
//         "MXN",
//         "NGN",
//         "HKD",
//         "MYR",
//         "USD",
//         "CAD",
//         "TRY",
//         "THB",
//         "PHP",
//         "ZMW",
//         "IDR",
//         "BRL",
//         "COP",
//         "PKR",
//         "BDT",
//       ],
//     },
//   ],
// };
